import * as i0 from '@angular/core';
import { EventEmitter, Component, Output, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

class SurescriptsUserProfile {
    constructor(init) {
        Object.assign(this, init);
    }
}

function UserProfileComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2)(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("title", "Current Environment: ", ctx_r0.environment, "");
    i0.ɵɵproperty("ngClass", ctx_r0.isStaging ? "text-bg-brand-orange" : "text-bg-gray-300");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.environmentDisplayString);
} }
function UserProfileComponent_div_1_a_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1, "Logout");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r2.logoutUrl, i0.ɵɵsanitizeUrl);
} }
function UserProfileComponent_div_1_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function UserProfileComponent_div_1_button_7_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.logoutClicked($event)); });
    i0.ɵɵtext(1, "Logout");
    i0.ɵɵelementEnd();
} }
function UserProfileComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "a", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "a", 6);
    i0.ɵɵtext(5, "View Profile");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, UserProfileComponent_div_1_a_6_Template, 2, 1, "a", 7)(7, UserProfileComponent_div_1_button_7_Template, 2, 0, "button", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r1.profile == null ? null : ctx_r1.profile.user == null ? null : ctx_r1.profile.user.lastName, ", ", ctx_r1.profile == null ? null : ctx_r1.profile.user == null ? null : ctx_r1.profile.user.firstName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("href", "", ctx_r1.profile == null ? null : ctx_r1.profile.baseUrl, "/profile", i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.logoutType === "hyperlink");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.logoutType === "event");
} }
/**
  * Example of usage:
  * <example-url>../assets/examples/shared/example-component-launch-sb.html?component=user-profile&version=9.0.2</example-url>
  */
class UserProfileComponent {
    constructor(http) {
        this.http = http;
        this.logout = new EventEmitter();
        this.isStaging = false;
        this.isProduction = false;
    }
    logoutClicked($event) {
        this.logout.emit($event);
    }
    ngOnInit() {
        this.logoutType = this.logoutType || 'hyperlink';
        this.logoutUrl = this.logoutUrl || 'logout';
        let requestUrl;
        if (!this.ssoBaseUrl && !this.dataUrl) {
            // Set default to match backend middleware.
            requestUrl = "/shared/profile";
        }
        else if (!this.dataUrl) {
            console.warn("ssoBaseUrl is deprecated and has been replaced by dataUrl");
            this.ssoBaseUrl = this.ssoBaseUrl.replace(/\/+$/, '');
            requestUrl = `${this.ssoBaseUrl}/app/v1/user/profile`;
        }
        else {
            requestUrl = this.dataUrl;
        }
        this.http.get(requestUrl, { withCredentials: true }).pipe(tap(resp => {
            this.environment = resp.environment;
            this.isStaging = this.environment === 'staging';
            this.isProduction = this.environment === 'production';
            this.profile = new SurescriptsUserProfile(resp);
            this.mapEnvVarToDisplayString();
        })).subscribe();
    }
    mapEnvVarToDisplayString() {
        switch (this.environment) {
            case 'localhost':
                this.environmentDisplayString = 'Localhost';
                break;
            case 'devint':
                this.environmentDisplayString = 'Devint';
                break;
            case 'qa-system-test':
                this.environmentDisplayString = 'Systest';
                break;
            case 'mn_loadtest':
                this.environmentDisplayString = 'Loadtest';
                break;
            case 'qa-prod-fix':
                this.environmentDisplayString = 'Prodfix';
                break;
            case 'staging':
                this.environmentDisplayString = 'Staging';
                break;
            default:
                this.environmentDisplayString = this.environment;
                break;
        }
    }
    static { this.ɵfac = function UserProfileComponent_Factory(t) { return new (t || UserProfileComponent)(i0.ɵɵdirectiveInject(i1.HttpClient)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserProfileComponent, selectors: [["surescripts-user-profile"]], inputs: { logoutUrl: "logoutUrl", logoutType: "logoutType", ssoBaseUrl: "ssoBaseUrl", dataUrl: "dataUrl" }, outputs: { logout: "logout" }, decls: 2, vars: 2, consts: [["class", "badge p-2 environment-identifier", 3, "ngClass", "title", 4, "ngIf"], ["class", "d-inline-block", "ngbDropdown", "", "placement", "bottom-right", "display", "dynamic", 4, "ngIf"], [1, "badge", "p-2", "environment-identifier", 3, "ngClass", "title"], ["ngbDropdown", "", "placement", "bottom-right", "display", "dynamic", 1, "d-inline-block"], ["ngbDropdownToggle", "", "data-toggle", "dropdown", 1, "nav-link"], ["ngbDropdownMenu", ""], ["id", "userprofile-profile-link", 1, "dropdown-item", 3, "href"], ["class", "dropdown-item", "id", "userprofile-logout-link", 3, "href", 4, "ngIf"], ["class", "dropdown-item", "id", "userprofile-logout-link", 3, "click", 4, "ngIf"], ["id", "userprofile-logout-link", 1, "dropdown-item", 3, "href"], ["id", "userprofile-logout-link", 1, "dropdown-item", 3, "click"]], template: function UserProfileComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, UserProfileComponent_span_0_Template, 3, 3, "span", 0)(1, UserProfileComponent_div_1_Template, 8, 5, "div", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.environment && !ctx.isProduction);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.profile == null ? null : ctx.profile.user);
        } }, dependencies: [i2.NgClass, i2.NgIf, i3.NgbDropdown, i3.NgbDropdownToggle, i3.NgbDropdownMenu] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserProfileComponent, [{
        type: Component,
        args: [{ selector: 'surescripts-user-profile', template: "<span *ngIf=\"environment && !isProduction\" class=\"badge p-2 environment-identifier\" [ngClass]=\"isStaging? 'text-bg-brand-orange' : 'text-bg-gray-300'\"  title=\"Current Environment: {{environment}}\"><strong>{{environmentDisplayString}}</strong></span>\n<div class=\"d-inline-block\" ngbDropdown placement=\"bottom-right\" *ngIf=\"profile?.user\" display=\"dynamic\">\n  <a ngbDropdownToggle class=\"nav-link\" data-toggle=\"dropdown\">{{profile?.user?.lastName}}, {{profile?.user?.firstName}}</a>\n  <div ngbDropdownMenu>\n      <a class=\"dropdown-item\" id=\"userprofile-profile-link\" href=\"{{profile?.baseUrl}}/profile\">View Profile</a>\n      <a class=\"dropdown-item\" id=\"userprofile-logout-link\" href=\"{{logoutUrl}}\" *ngIf=\"logoutType === 'hyperlink'\">Logout</a>\n      <button class=\"dropdown-item\" id=\"userprofile-logout-link\" (click)=\"logoutClicked($event)\" *ngIf=\"logoutType === 'event'\">Logout</button>\n  </div>\n</div>\n" }]
    }], () => [{ type: i1.HttpClient }], { logout: [{
            type: Output
        }], logoutUrl: [{
            type: Input
        }], logoutType: [{
            type: Input
        }], ssoBaseUrl: [{
            type: Input
        }], dataUrl: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(UserProfileComponent, { className: "UserProfileComponent", filePath: "lib/user-profile.component.ts", lineNumber: 15 }); })();

class SurescriptsUser {
    constructor(init) {
        Object.assign(this, init);
    }
}

class UserProfileModule {
    static { this.ɵfac = function UserProfileModule_Factory(t) { return new (t || UserProfileModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UserProfileModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            HttpClientModule,
            NgbDropdownModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserProfileModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    NgbDropdownModule
                ],
                declarations: [UserProfileComponent],
                exports: [UserProfileComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UserProfileModule, { declarations: [UserProfileComponent], imports: [CommonModule,
        HttpClientModule,
        NgbDropdownModule], exports: [UserProfileComponent] }); })();

/*
 * Public API Surface of user-profile
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SurescriptsUser, SurescriptsUserProfile, UserProfileComponent, UserProfileModule };
